import {useScopeTranslation} from '@uigstudio/uig-nextjs-helper';

import useSelect from '~molecules/SortSelect/useSelect';

import {DropDown, Option, Select, Wrapper} from './styles';

const SortSelect = () => {
    const t = useScopeTranslation('list', 'select');
    const {ref, options, onSelect, selectedLabel, open, toggleOpen} = useSelect();

    return (
        <Wrapper ref={ref}>
            <Select onClick={toggleOpen}>
                {open || !selectedLabel ? t('sortBy') : selectedLabel}
            </Select>
            <DropDown open={open}>
                {options.map((option) => (
                    <Option
                        selected={option.selected}
                        key={`${option.sortBy}_${option.sortDirection}`}
                        onClick={() => onSelect(option)}
                    >
                        {option.label}
                    </Option>
                ))}
            </DropDown>
        </Wrapper>
    );
};

export default SortSelect;
